import awaitWrap from './await-wrap.js';

export default async (
  {
    $vs,
    title,
    text,
    action,
  },
) => {
  $vs.dialog({
    accept: async () => await awaitWrap(action)(),
    type: 'confirm',
    color: 'danger',
    title,
    text,
    acceptText: 'Usuń',
    cancelText: 'Wróć',
  });
};
